import { DEFAULT_BRANCH_ID } from '@wix/a11y-wizard-common';
import { accessibilityAnalyzerReaderQueryRuleExecutionResultsByPage as queryRuleExecutionResultsByPageV2 } from '@wix/ambassador-promote-accessibility-v2-rule-execution-result/http';
export const queryRuleExecutionResults = async (httpClient, errorHandler, itemType, pageId, branchId) => {
  const LIMIT = 200;
  const {
    withErrorHandler
  } = errorHandler;
  const allRuleExecutionResults = [];
  let cursor;
  let lastPage = false;
  await withErrorHandler(async () => {
    do {
      const response = await httpClient.request(queryRuleExecutionResultsByPageV2({
        itemType,
        pageId,
        paginationRequest: {
          cursor,
          maxNumberOfRecords: LIMIT
        }
      }));
      const {
        paginationResponse,
        ruleExecutionResults
      } = response.data;
      allRuleExecutionResults.push(...(ruleExecutionResults ?? []));
      cursor = paginationResponse == null ? void 0 : paginationResponse.cursor;
      lastPage = (paginationResponse == null ? void 0 : paginationResponse.lastPage) ?? false;
    } while (!lastPage);
  }, {
    errorCodesMap: {}
  });
  if (!branchId) {
    return allRuleExecutionResults;
  }
  const filteredByBranch = allRuleExecutionResults.filter(result => {
    var _result$metadata;
    return ((_result$metadata = result.metadata) == null ? void 0 : _result$metadata.branchId) === branchId;
  });
  if (filteredByBranch.length > 0) {
    return filteredByBranch;
  }
  return allRuleExecutionResults.filter(result => {
    var _result$metadata2;
    return ((_result$metadata2 = result.metadata) == null ? void 0 : _result$metadata2.branchId) === DEFAULT_BRANCH_ID;
  });
};
//# sourceMappingURL=query-rule-execution-results.js.map